export const variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const itemVariants = {
  hidden: { opacity: 0, y: 0 },
  visible: { opacity: 1, y: 0 },
};
